import React from 'react';
import Svg, { Path, Circle, Rect } from 'react-native-svg';
import { CustomSVGProps, getBaseSVGProps } from './utils';

const Imaging: React.FC<CustomSVGProps> = (props) => {
    return (
        <Svg {...getBaseSVGProps(props, 60)} fill="none">
            <Rect
                x={3.00006}
                y={9.00001}
                width={54}
                height={38.3478}
                rx={3}
                fill="#fff"
                stroke={props.color}
                strokeWidth={2}
            />
            <Path d="M10.041 42.891l12.568-21.34 12.567 21.34H10.041z" fill="#fff" stroke={props.color} />
            <Path d="M31.983 43.044l8.886-15.392 8.886 15.392H31.983z" fill="#fff" stroke={props.color} />
            <Circle cx={46.6521} cy={18.7391} r={4.97826} fill="#fff" stroke={props.color} />
        </Svg>
    );
};

export default React.memo(Imaging);
